import React from 'react'

class PlusMinusButton extends React.Component {
  render() {
    const { numberOfDependants, handleNumberOfDependants} = this.props

    return (
      <div className='input-group input-plus-minus'>
        <span className='input-group-btn'>
          <button id="minus" className='btn btn-line btn-number' onClick={() => handleNumberOfDependants('minus')}>
            <div id="minus" className='material-icons m-auto' onClick={() => handleNumberOfDependants('minus')}>
              remove
            </div>
          </button>
        </span>
        <input className='form-control input-number' value={numberOfDependants} readOnly />
        <span className='input-group-btn'>
          <button id="plus" className='btn btn-line btn-number' onClick={() => handleNumberOfDependants('plus')}>
            <div id="plus" className='material-icons m-auto' onClick={() => handleNumberOfDependants('plus')}>
              add
            </div>
          </button>
        </span>
      </div>
    )
  }
}

export default PlusMinusButton;
